module.exports = __webpack_public_path__ + "img/imagen6.28c7406a.png";